<!-- body wrapper  -->
<div class="body-wrapper">

    <!-- ==========page banner ========== -->
    <div class="page-ban">
        <div class="page-ban-inner">
            <div class="container">
                <div class="page-content">
                    <h2 class="page-title">
                        Product Details
                    </h2>

                    <div class="page-url">
                        <a routerLink="/" class="old-page">Home </a> /
                        <a [routerLink]="['/product', productType]" class="old-page ms-2">{{productType | titlecase}}
                            Machinery </a> /
                        <p class="">Warping Machine</p> <!-- Need to do dynamic -->
                    </div>

                </div>
            </div>
        </div>
    </div>
    <!-- ==========page banner end ====== -->

    <!-- ===============about section ============ -->
    <section>
        <!-- about  -->
        <div class="about cpy-8 ">
            <!-- container  -->
            <div class="container">
                <!-- row  -->
                <div class="row align-items-center">
                    <div class="col-lg-4 col-md-4 col-sm-12 col-12 pb-4 product-details-page">
                        <div class="post-card product-list-main">
                            <div class="post-img news position-relative">
                                <img src="assets/img/products/machine1.jpg" class="product-image" alt="Product Image">
                                <div class="il-bg-black"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-12 col-12 mb-4">
                        <div class="about-content">
                            <div class="sec-head mb-3">
                                <h2 class="inside-head">High-Speed Direct Warping Machine</h2>
                            </div>

                            <div class="about-content-inner mb-2">
                                <p class="pb-0 mb-3">The High-Speed Direct Warping Machine is a precision-engineered
                                    textile machine designed to convert yarn packages into warp beams at high
                                    efficiency, speed, and accuracy. It is a crucial component in the weaving
                                    preparation process, particularly in denim, shirting, suiting, and technical textile
                                    production. This machine directly winds yarns from creel-mounted cones onto a warp
                                    beam, aligning them parallel with consistent tension, and is widely used in modern
                                    textile manufacturing for its productivity and versatility.</p>

                                <p class="pb-0 mb-3">The High-Speed Direct Warping Machine is an ideal solution for
                                    modern textile mills aiming for maximum efficiency, fabric consistency, and
                                    high-speed weaving preparation. Its adaptability, automation, and durability make it
                                    an indispensable asset in high-volume fabric production environments.</p>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="row mt-4">
                    <div class="col-lg-4 col-md-5 col-sm-12 col-12 mb-3" *ngIf="productKeyFeatures?.length > 0">
                        <div class="team-sec-title mb-4">
                            <h3 class="inside-head mb-2">Features:</h3>
                        </div>
                        <p class="mb-2" *ngFor="let feature of productKeyFeatures;">
                            <i class="icofont-check-circled theme-color fs-5"></i>
                            {{feature?.name}}
                        </p>
                    </div>

                    <div class="col-lg-8 col-md-7 col-sm-12 col-12 mb-3 technical-specifications-table" *ngIf="productKeyFeatures?.length > 0">
                        <div class="team-sec-title mb-4">
                            <h3 class="inside-head mb-2">Technical Specifications:</h3>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-bordered border-warning">
                                <tbody>
                                    <tr *ngFor="let techSpecif of productTechnicalSpecifications;">
                                        <td class="op-title">{{techSpecif?.title}}:</td>
                                        <td>{{techSpecif?.content}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <!-- row end  -->
            </div>
            <!-- container  -->
        </div>
        <!-- about end  -->
    </section>
    <!-- ============about section end ========= -->
</div>
<!-- body wrapper end -->